<icc-list
        [searchable]="true"
        [items]="fillings"
        [itemTemplate]="'itemImgTitleDescription'"
        (select)="selectFilling($event)"
        [selected]="selectedFilling"
        [vertical]="true"
></icc-list>
